import Home from './views/Home.vue';
import Quote from './views/Quote.vue';
import Information from './views/Information.vue';
import MyQuotes from './views/MyQuotes.vue';
import Cards from './views/apartments/users/Users.vue';

export const PrivateRoutes =
[
	{
		path: '/',
		component: Home,
		name: 'index'
	},
	{
		path: '/cotizaciones',
		component: Quote,
		name: 'quote'
	},
	{
		path: '/mis-cotizaciones',
		component: MyQuotes,
		name: 'myquotes'
	},
	{
		path: '/datos',
		component: Information,
		name: 'information'
	},
	{
		path: '/tarjetas',
		component: Cards,
		name: 'user'
	}
]